
import { useNavigate } from 'react-router-dom';
import { Job } from '@/components/jobs/types';

export const useJobOverviewNavigation = (job: Job) => {
  const navigate = useNavigate();

  const navigateToApplicationsTab = () => {
    navigate(`/jobs/${job.id}#applications`);
  };

  const navigateToApplicationsWithFilter = (filter?: string) => {
    const hash = filter ? `applications?filter=${filter}` : 'applications';
    navigate(`/jobs/${job.id}#${hash}`);
  };

  const navigateToCandidateDetail = (candidateId: string) => {
    navigate(`/candidates/${candidateId}`);
  };

  const navigateToInterviewsTab = () => {
    navigate(`/jobs/${job.id}#interviews`);
  };

  const navigateToMatchingCandidates = () => {
    navigate(`/jobs/${job.id}#matching-candidates`);
  };

  return {
    navigateToApplicationsTab,
    navigateToApplicationsWithFilter,
    navigateToCandidateDetail,
    navigateToInterviewsTab,
    navigateToMatchingCandidates,
  };
};
